import i18n from 'i18n';

export default function getPCRating(namePG) {
  var dictionary = {
    PG13: { age: '12+', priority: 1 },
    'PG-13': { age: '12+', priority: 1 },
    'TV-14': { age: '12+', priority: 1 },
    'tv-14': { age: '12+', priority: 1 },
    R: { age: '16+', priority: 2 },
    'TV-MA': { age: '16+', priority: 2 },
    'tv-ma': { age: '16+', priority: 2 },
    'NC-17': { age: '18+', priority: 3 },
    NC17: { age: '18+', priority: 3 },
    'TV-G': { age: i18n.t('pc.age.noLimits'), priority: 0 },
    'tv-g': { age: i18n.t('pc.age.noLimits'), priority: 0 },
    G: { age: i18n.t('pc.age.noLimits'), priority: 0 },
    PG: { age: i18n.t('pc.age.noLimits'), priority: 0 },
    NR: { age: i18n.t('pc.age.notRated'), priority: 0 },
    UR: { age: i18n.t('pc.age.notRated'), priority: 0 },
  };

  return dictionary[namePG] || namePG;
}
